type Paging = {
  totalElements?: number;
  limit?: string | number;
};

/** Number of pages an API `paging` block describes; 1 when there is nothing to page. */
export const getPagesCount = (paging?: Paging): number => {
  const totalElements = Number(paging?.totalElements ?? 0);
  const limit = Number(paging?.limit ?? 0);

  if (!totalElements || !limit) return 1;

  return Math.ceil(totalElements / limit);
};
